var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "H5\u6253\u5F00\u94FE\u63A5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-304.000000, -465.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5206\\u4EAB",
    transform: "translate(304.000000, 465.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1.71428571 L12,3.42857142 C7.266,3.42857142 3.42857142,7.266 3.42857142,12 C3.42857142,16.734 7.266,20.5714286 12,20.5714286 C16.734,20.5714286 20.5714286,16.734 20.5714286,12 L22.2857143,12 C22.2857143,17.6802857 17.6802857,22.2857143 12,22.2857143 C6.31971429,22.2857143 1.71428571,17.6802857 1.71428571,12 C1.71428571,6.31971429 6.31971429,1.71428571 12,1.71428571 Z M20.3074286,4.57971429 L12.3548571,12.5322857 L11.1428571,11.3202857 L19.0345714,3.42857142 L14.3074286,3.42857142 L14.3074286,1.71428571 L22.0217143,1.71428571 L22.0217143,9.42857142 L20.3074286,9.42857142 L20.3074286,4.57971429 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.17e4f04f8e852c0d348062b73d7e012f.svg";
export { ForwardRef as ReactComponent };